import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import { CModal } from '@coreui/react';
import { Loader } from '../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';

const InstituteList = () => {
    const authorizedAxios = generateAxiosInstance();
    const [instituteList, setInstituteList] = useState([]);
    const [activation, setActivation] = useState(null);
    const [showDetails, setShowDetails] = useState("");
    const [visible, setVisible] = useState(false);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [instituteIdSort, setInstituteIdSort] = useState(null);
    const [instituteNameSort, setInstituteNameSort] = useState(null);
    const [principleNameSort, setPrincipleNameSort] = useState(null);
    const [emailSort, setEmailSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["instituteId", "instituteName", "inchargeName", "email", "contactNumber", "contactNumber2"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getInstituteList();
    }, [activation]);

    const getInstituteList = async () => {
        try {
            setLoading(true);
            const apiUrl = `/get-institute-master-v2`;
            const response = await authorizedAxios.get(apiUrl);
            setInstituteList(response.data.result);
        } catch (error) {
            setInstituteList([])
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getInstituteList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setInstituteList(await searchArray("A", "/get-institute-master-v2", searchKeys, searchValue.trim()));
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(instituteList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(instituteList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > instituteList.length) {
            endIndex = instituteList.length;
        }
        setStartIndex(startIndex);
        console.log(instituteList)
        setDisplayedData(instituteList.slice(startIndex, endIndex));
    }, [instituteList, currPage, itemsPerPage]);


    const changeActive = (id, activationStatus) => {
        setLoading(true);
        const data = {}
        data.id = id;
        data.adminDeActivate = activationStatus;
        const apiUrl = `/institute-de-activation`;
        authorizedAxios && authorizedAxios.patch(apiUrl, data)
            .then(response => {
                setActivation(!activation);
                setTimeout(() => {
                    Swal.fire({ text: response.data.message });
                    console.log('Data:', response.data);
                }, 100);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    useEffect(() => {
        if (instituteIdSort == true || instituteIdSort == false) {
            setInstituteNameSort(null);
            setPrincipleNameSort(null);
            setEmailSort(null);
        }
    }, [instituteIdSort])

    useEffect(() => {
        if (instituteNameSort == true || instituteNameSort == false) {
            setInstituteIdSort(null);
            setPrincipleNameSort(null);
            setEmailSort(null);
        }
    }, [instituteNameSort])

    useEffect(() => {
        if (principleNameSort == true || principleNameSort == false) {
            setInstituteIdSort(null);
            setInstituteNameSort(null);
            setEmailSort(null);
        }
    }, [principleNameSort])

    useEffect(() => {
        if (emailSort == true || emailSort == false) {
            setInstituteIdSort(null);
            setInstituteNameSort(null);
            setPrincipleNameSort(null);
        }
    }, [emailSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Institute List</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-list"></i> Institute List</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                {visible && <CModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    aria-labelledby="LiveDemoExampleLabel"
                                                    onIni
                                                >
                                                    <div className="book book-modal">
                                                        <h2 className='table-header-like'>Full Details</h2>
                                                        <div className='page'>
                                                            <p>Institute Id: {showDetails.instituteId}</p>
                                                            <p>Institute Name: {showDetails.instituteName}</p>
                                                            <p>Principle Name: {showDetails.inchargeName}</p>
                                                            {showDetails.address && <p>Address: {showDetails.address}</p>}
                                                            {showDetails.state && <p>State: {showDetails.state}</p>}
                                                            {showDetails.district && <p>District: {showDetails.district}</p>}
                                                            {showDetails.city && <p>City: {showDetails.city}</p>}
                                                            {showDetails.pincode && <p>Pincode: {showDetails.pincode}</p>}
                                                            <p>Contact Number: {showDetails.contactNumber}</p>{showDetails.contactNumber2 && <p>, {showDetails.contactNumber2}</p>}
                                                            <p>Email: {showDetails.email}</p>
                                                            {showDetails.website && <p>Website: {showDetails.website}</p>}
                                                            {showDetails.allottedSections && <p>Allocated Sections: {showDetails.allottedSections}</p>}
                                                        </div>
                                                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                            Close
                                                        </button>
                                                    </div>
                                                </CModal>}

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col" className='ins_id'>
                                                                            Institute Id
                                                                            <SortIcon sortState={instituteIdSort} setSortState={setInstituteIdSort} setData={setInstituteList} setCurrPage={setCurrPage} sortingPath={"instituteId"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Institute Name
                                                                            <SortIcon sortState={instituteNameSort} setSortState={setInstituteNameSort} setData={setInstituteList} setCurrPage={setCurrPage} sortingPath={"instituteName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Principle Name
                                                                            <SortIcon sortState={principleNameSort} setSortState={setPrincipleNameSort} setData={setInstituteList} setCurrPage={setCurrPage} sortingPath={"inchargeName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Email
                                                                            <SortIcon sortState={emailSort} setSortState={setEmailSort} setData={setInstituteList} setCurrPage={setCurrPage} sortingPath={"email"} />
                                                                        </th>
                                                                        <th scope="col" className='ins_id'>Phone No</th>
                                                                        <th scope='col'>View</th>
                                                                        <th scope='col' className='text-center toggle_switch_id'>Active<br />/Inactive</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((institute, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td className='ins_id'>{institute.instituteId}</td>
                                                                                        <td>{institute.instituteName}</td>
                                                                                        <td>{institute.inchargeName}</td>
                                                                                        <td>{institute.email}</td>
                                                                                        <td className='ins_id'>{institute.contactNumber} <br /> {institute.contactNumber2}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowDetails(institute);
                                                                                                setVisible(!visible)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                        </td>
                                                                                        <td className='toggle_switch_id'>
                                                                                            <div className={`toggle-container margin-inline ${institute.adminDeActivate ? '' : 'active'}`} onClick={() => changeActive(institute.id, institute.adminDeActivate)}>
                                                                                                <div className="toggle-background"></div>
                                                                                                <div className="toggle-switch"></div>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Students Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={instituteList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteList;
